
<template>

  <div class="hello" style="">
    <div class="menu-row">
       <t-back-button :to="{name:'WordsPage',params:{thinkID:thinkID}}" />

       <span class="t-button" @click="ShowPrint();"> <i class="fas fa-print" ></i>印刷ページ</span>
       <!-- <span class="t-button" @click="generate();"> <i class="fas fa-print" ></i>画像</span> -->

    </div>
   
    
    <!-- <router-link　class="back" :to="{name:'WordsPage',params:{thinkID:thinkID}}"><i class="fas fa-chevron-left"></i><ruby><rb>戻</rb><rt>もどる</rt></ruby>る</router-link> -->
    <!-- thinkID={{thinkID}} ----wordID={{wordID}} -->
    <title-component class="c-title" :title="thinkData.title"></title-component>
    <tthink-component :readonly="false" :autoGrow="true" ></tthink-component>
  </div>
</template>

<script>
import Title from "../atoms/Title";
import TThink from "../organisms/TThinkEditor";
import Words from "../Words";
import TBackButton from "../atoms/TBackButton";

import html2canvas from "html2canvas";

export default {
  name: "TThinkPage",
  components: {
    "title-component": Title,
    "tthink-component": TThink,
    "words-component": Words,
    TBackButton
  },

  computed: {
    thinkData() {
      return this.$store.getters.thinkData;
    }
  },
  mounted() {
    window.scrollTo(0, 0); //スクロールをトップにもっていく

    //Notice: storeのthinkDataがセットされていない場合
    //1.think一覧を取得
    //2.現在のthinkIDと照合するかチェック
    //3.照合する＝StoreにSetThinkし、GetWordsを実行
    //3.照合NG = thinkpageへリダイレクト
    //4-1.取得したwordsデータを照合し、OKだったらSetActiveWord,NGだったらword一覧へ戻る
    if (this.thinkData.id === undefined) {
      var callback = function(result, msg) {
        if (result === false) {
          alert(msg);
          return;
        }
        var items = this.$store.getters.thinkItems;
        var itemsCount = items.length;
        for (var i = 0; i < itemsCount; i++) {
          if (items[i].id === this.thinkID) {
            //照合OK:選択
            this.$store.commit("SetThink", items[i]);

            //選択したデータの[Words]を取得する
            var callbackGetWords = function(result, msg) {
              var isExistWord = false;
              var result = this.$store.getters.thinkData.words.filter(
                function(item, index) {
                  //word照合:OK
                  if (item.id === this.wordID) {
                    item.index = index + 1; //Notice:ここでSEQをセットしないと、表示が「０」になる
                    this.$store.commit("SetActiveWord", item);
                    isExistWord = true;
                    return true;
                  }
                }.bind(this)
              );

              //word照合:NG=指定のIDのwordが存在しない
              //=words一覧へもどる
              if (isExistWord === false) {
                this.$router.push({
                  name: "WordsPage",
                  params: { thinkID: this.thinkData.id }
                });
              }
            }.bind(this);
            this.$store.dispatch("GetWords", { callback: callbackGetWords });
            return;
          }
        }

        //照合NG
        //データが存在しない場合はthinkpageへリダイレクト
        if (this.thinkData.id === undefined) {
          this.$router.push({ path: "/thinkpage" });
          return;
        }
      }.bind(this);

      //1.think一覧を取得
      this.$store.dispatch("GetThinks", { callback: callback });
    }
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  props: {
    thinkID: String,
    wordID: String
  },
  methods: {
    ShowPrint() {
      this.$router.push({
        name: "PrintPage",
        params: { wordID: this.wordID, thinkID: this.thinkID }
      });
    },
    generate() {
      alert("sss");
      html2canvas(document.querySelector(".hello")).then(function(canvas) {
        var result = document.querySelector("#result");
        result.innerHTML = "";
        result.appendChild(canvas);
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/style/common.scss";

.menu-row {
  display: flex;
  justify-content: start;
  align-items: center;
}

.t-button {
  cursor: pointer;
  color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  display: inline-block;
  border: none;
  margin-left: auto;
  background: #42b983;
  text-align: center;
  border-radius: 25px;
  padding-top: 8px;
  padding-bottom: 5px;
  //margin-top:-15px;
  vertical-align: middle;
  letter-spacing: 0.03em;
  font-weight: 600;
  font-size: 16px;
  transition: all 200ms 0s ease;

  box-shadow: 0px 4px #257e56;

  &:hover {
    background: #308f64;
  }

  & > i {
    margin-right: 6px;
  }
}

.c-title {
  margin-bottom: 20px;
  @include mq-down(md) {
    margin-bottom: 15px;
  }
}

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/TThinkPage.vue